import { computed } from 'vue'
import api from '../index'

export default {
  // // 后端获取路由数据
  // routeList: () => api.get('app/route/list', {
  //   baseURL: '/mock/',
  // }),

  // // 基于文件系统路由模式下，后端获取导航菜单数据
  // menuList: () => api.get('app/menu/list', {
  //   baseURL: '/mock/',
  // }),

  // 启动策略
  startStrategy: (data: {
    strategy_name: string
    exchange_params: {
      exchange_name: string
      account: string
      exchange_env: string
    }
    params: object
  }) => api.post('/strategy/start', data),

  // 停止策略
  stopStrategy: (data: {
    strategy_name: string
    exchange_params: {
      exchange_name: string
      account: string
      exchange_env: string
    }
    params: object
  }) => api.post('/strategy/stop', data),

  // 更新策略
  updateStrategy: (data: {
    strategy_name: string
    exchange_params: {
      exchange_name: string
      account: string
      exchange_env: string
    }
    params: object
  }) => api.post('/strategy/change_params', data),

  // 获取正在运行的策略
  getRunning: () => api.get('/strategy/running'),

  // get my dashboardAccount
  getMyDashboardAccount: (
  ) => api.get('/account/me'),

  // 获取用户列表
  getAccount: (data: {
    exchange_name: string
    trade_env: string
  }) => api.post('/account/query_account', data),

  // 获取symbol 列表
  getSymbol: (data: {
    exchange_name: string
  }) => api.post('/exchange/symbol', data),

  // 获取 position 列表
  getPosition: () => api.get('/position/all'),

  // 获取 profit 列表
  getProfit: () => api.get('/profit/all'),
  getProfitNew: () => api.get('/profit/all_new'),

  // 获取 position 列表
  getOptionPosition: () => api.get('/option/position'),

  // 获取 open option order 列表
  getOpenOption: () => api.get('/option/open_order'),

  // 创建 option 订单
  createOptionOrder: (data: {
    symbol: string
    price: string
    amount: string
    side: string
    order_type: string
  }) => api.post('/option/create_order', data),

  // 取消 option 订单
  cancelOptionOrder: (data: {
    symbol: string
    order_id: string
  }) => api.post('/option/cancel_order', data),

  // 获取 option 信息
  // 返回数据格式：
  // {"status":1,"error":"","data":{"option_info":{"BTC":{"240924":[61500.0,61500.0,62000.0]}}}
  getOptionInfo: () => api.get('/option/task/get_info'),

  // 获取 filter 信息
  getFilterInfo: () => api.get('/option/task/get_filter'),

  // 获取 运行中的任务 信息
  getRunningTask: () => api.get('/option/task/query_running'),

  // 删除 运行中的任务
  deleteRunningTask: (data: {
    task_id: string
  }) => api.post('/option/task/delete_task', data),

  // 添加期权任务
  addOptionTask: (data: {
    task_id: string
    task_params: object
  }) => api.post('/option/task/add_task', data),

  // 添加期货策略账号
  futuresAddAccount: (data: {
    strategy: string
    account: string
    amount_type: string
    amount_params: string
  }) => api.post('/futures/running_strategy/add_strategy', data),

  // 更新期货策略账号
  futuresUpdateAccount: (data: {
    strategy: string
    account: string
    amount_type: string
    amount_params?: string | null
    status?: string | null
  }) => api.post('/futures/running_strategy/update_strategy', data),

  // 删除账号:
  futuresDeleteAccount: (data: {
    strategy: string
    account: string
    amount_type: string
    amount_params: string
  }) => api.post('/futures/running_strategy/delete_strategy', data),

  // 查询运行中策略账号
  futuresQueryAll: () => api.get('/futures/running_strategy/query_all'),

  // 手动交易
  futuresManualTrade: (data: {
    strategy: string
    account: string
    amount: number
    price: number
    side: string
    trade_type: string
    positionIdx: string
  }) => api.post('/futures/manual_trading/create_order', data),

  // 查询手动交易记录
  futuresQueryManualTrade: () => api.get('/futures/manual_trading/get_order'),

  // 查询目前的账号
  userQueryAll: () => api.get('/user/query_all'),

  // 查询所有策略
  futresQueryStrategy: () => api.get('/futures/strategy/query_all'),

  getStrategyInfo: (data: object) => api.post('/futures/strategy/get_strategy_info', data),

  getAccountInfo: (data: object) => api.post('/futures/strategy/get_account_info', data),
  queryStrategy: (data: object) => api.post('/futures/running_strategy/query_strategy', data),

  // 添加用户
  userAdd: (data: {
    ac: string
    ex: string
    env: string
    kkk: string
    sss: string
  }) => api.post('/user/add', data),

  // 查询连续盈利
  // 返回数据格式：
  // {"status":1,"error":"","data":{"result":{strategy_name: {continue_pl_count: 10, continue_pl_list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], pl_type: 'profit'}}}}
  getContinuousProfit: () => api.get('/strategy/continue_pl'),

  // 查询账号订单
  getAccountOrder: (data: {
    account: string
    symbol: string
  }) => api.post('/tmp/fetch_history', data),

  // 查询止损不执行的信息
  getLossUnableInfo: (data: {
    exchange?: string
    account?: string
    symbol?: string
    strategy?: string
    status?: string
  }) => api.post('/futures/loss_unable/query_loss_unable_info', {
    exchange: undefined,
    account: undefined,
    symbol: undefined,
    strategy: undefined,
    status: undefined,
    ...data,
  }),

  // 反向开仓
  updateLimitOrder: (data: {
    record_id: string
    update_type: string
    price: number
    trade_type: string
  }) => api.post('/futures/loss_unable/update_limit_order', data),
  // 添加对冲任务
  addHedgeTask: (data: {
    symbol: string
    exchange: string
    exchange_env: string
    amount: number
    activate_price: number
    stop_loss_per: number
    gap_price_per: number
    stop_price: number
    take_profit_per_list: number[]
    take_profit_trailing_list: number[]
    take_profit_amount_per_list: number[]
    action: string
    account: string
  }) => api.post('/api/tasks', data),
  // // 四、停止任务
  // stopHedgeTask: (data: {
  //   task: string
  // }) => api.put('/api/tasks', data),
  // 修改任务状态
  updateHedgeTask: (data: {
    task: string
    status: string
  }) => api.put(`/api/tasks/${data.task}`, { status: data.status }),

  // 查询对冲任务
  getHedgeTask: (data: {
    enable: string
  }) => api.post('/api/get_tasks', data),

  // 查询对冲任务详细
  getHedgeTaskDetail: (data: string) => api.get(`/api/tasks/${data}`),
  // 修改

  // eidtHedgeTask: (data: string) => api.put(`/api/tasks/${data}`),
  eidtHedgeTask: (data: string, params: object) => api.put(`/api/tasks/${data}`, params),

  // ...........
  // 移仓相关接口
  // ...........
  // 获取移仓信息
  getMovePositionInfo: (
    data: {
      page: number
      size: number
    },
  ) => api.post('/infos/move_position', data),

  // 期权手动交易
  deribitOptionMarketData: (
    data: {
      currency: string
      expiration_date: string | null
    },
  ) => api.post('/infos/deribit_option_market_data', data),

  // 获取用户账号信息
  deribitGetUserAccount: () => api.get('/infos/deribit_infos'),

  // 获取期权信息
  deribitOptionInfo: (currency: string) => api.post(`/infos/deribit_instruments/${currency}`),

  // 创建期权订单
  deribit_create_order: (
    data: {
      operator: string | null
      account_name: string
      symbol: string
      order_type: string
      side: string
      amount: number
      price: number
      position_side: string
    },
  ) => api.post('/infos/deribit_create_order', data),

  // 取消期权订单
  deribit_cancel_order: (
    data: {
      operator: string | null
      account_name: string
      symbol: string
      order_id: string
    },
  ) => api.post('/infos/deribit_cancel_order', data),

  // 创建用户组
  optionCreateGroup: (data: {
    group_name: string
    group_description: string
  }) => api.post('/infos/option/create_group', data),

  // 查询用户组
  optionQueryGroup: () => api.get('/infos/option/get_group'),

  // 删除用户组
  optionDeleteGroup: (data: {
    group_name: string
  }) => api.delete(`/infos/option/delete_group/${data.group_name}`),

  // 更新用户描述
  optionUpdateGroup: (data: {
    group_name: string
    group_description: string
  }) => api.post('/infos/option/update_group', data),

  // 添加用户到用户组
  optionAddUserToGroup: (data: {
    group_name: string
    account_name: string
    amount_ratio: number
    margin_ratio: number
    min_amount: number
    max_amount: number
  }) => api.post('/infos/option/create_group_account', data),

  // 查询用户组用户
  optionQueryUserGroup: (data: {
    group_name: string
  }) => api.post('/infos/option/get_group_account', data),

  // 删除用户组用户
  optionDeleteUserGroup: (data: {
    group_name: string
    account_name: string
  }) => api.post('/infos/option/delete_group_account', data),

  // 修改用户组用户
  optionUpdateUserGroup: (data: {
    group_name: string
    account_name: string
    amount_ratio: number | null
    margin_ratio: number | null
    min_amount: number | null
    max_amount: number | null
  }) => api.post('/infos/option/update_group_account', data),

  // 添加移动设备检测
  isMobile: computed(() => {
    return window.innerWidth <= 768
  }),

  // 查询组管理列表
  getManageGroups: () => api.get('/api/groups'),

  // 添加组管理
  addManageGroups: (data: {
    name: string
    enable: boolean
    auth: object
    exchange_accounts: object
    strategies: object
  }) => api.post('/api/groups', data),

  // 编辑组管理
  editManageGroups: (data: {
    name: string
    enable: boolean
    auth: object
    exchange_accounts: object
    strategies: object
  }, groupId: string) => api.put(`/api/groups/${groupId}`, data),

  // 查询交易所账号列表
  getExchangeAccounts: () => api.get('/api/exchange_accounts'),

  // 查询用户管理列表
  getManageUsers: () => api.get('/api/users'),

  // 编辑用户管理
  editManageUser: (data: {
    name: string
    email: string
    groups: object
  }, userId: string) => api.put(`/api/users/${userId}`, data),

  // 查询策略管理列表
  getManageStrategies: () => api.get('/api/strategies'),

  // 编辑交易所账号
  editExchangeAccount: (data: {
    account: string
    env: string
    exchange: string
    api_key: string
    secret: string
  }, id: string) => api.put(`/api/exchange_accounts/${id}`, data),

  // 添加交易所账号
  addExchangeAccount: (data: {
    account: string
    env: string
    exchange: string
    api_key: string
    secret: string
  }) => api.post(`/api/exchange_accounts`, data),
}
